import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./assets/css/all.min.css";
import "./assets/css/animate.min.css";
import "./index.css";
import "./assets/css/coloring.css";
import Header from './components/Header';
import Home from "./routes/Home";
import About from "./routes/About";
import Services from "./routes/Services";
import Gallery from "./routes/Gallery";
import Testimonials from "./routes/Testimonials";
import Pricing from "./routes/Pricing";
import Contact from "./routes/Contact";
import BookNow from "./routes/BookNow";
import Terms_And_Conditions from "./routes/Terms_And_Conditions";
import Refund_And_Cancellation_Policy from "./routes/Refund_And_Cancellation_Policy";
import Privacy_Policy from "./routes/Privacy_Policy";
import PaymentSuccess from "./routes/PaymentSuccess";
import ThankYou from "./routes/ThankYou";
import PaymentFailed from "./routes/PaymentFailed";


import Footer from './components/Footer';


import WOW from 'wowjs';
import { Route, Routes } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "./components/Loader";

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const wow = new WOW.WOW();
        wow.init();

        const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

        const noscript = document.createElement("noscript");
        noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KVHSM9BH"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
        document.body.insertAdjacentElement("afterbegin", noscript);

    }, []);

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <Helmet>
                <script>
                    {`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-KVHSM9BH');
                `}
                </script>
            </Helmet>

            <ToastContainer />
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book-now" element={<BookNow />} />
                <Route path="/terms-conditions" element={<Terms_And_Conditions />} />
                <Route path="/refund-cancellation-policy" element={<Refund_And_Cancellation_Policy />} />
                <Route path="/privacy-policy" element={<Privacy_Policy />} />
                <Route path="/payment-success" element={<PaymentSuccess />} /> 
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/payment-failed" element={<PaymentFailed />} />
                <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
        </>
    );
}

export default App;